import { useProgress } from '@/context/ProgressContext';
import { Star, X } from 'lucide-react';

const MESSAGES = [
  'Amazing work! Show your bhai what you built!',
  'You are a coding star! Your bhai will be so proud!',
  'Level up! Call your bhai and tell him!',
  'Incredible! Your bhai is going to love this!',
  'You did it! Share this moment with your bhai!',
  'Superstar coder! Your bhai should see this!',
  'Wow, look at you go! Tell your bhai right now!',
];

const CelebrationModal = () => {
  const { showCelebration, dismissCelebration } = useProgress();

  if (!showCelebration) return null;

  const message = MESSAGES[showCelebration.itemId % MESSAGES.length];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="celebration-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={dismissCelebration} />

      <div className="confetti-container">
        {Array.from({ length: 50 }, (_, i) => (
          <div
            key={i}
            className="confetti-piece"
            style={{
              '--color': ['#FF0099', '#1E90FF', '#16FF00', '#FFED00', '#FF5E00'][i % 5],
              animationDelay: `${Math.random() * 0.6}s`,
              left: `${Math.random() * 100}%`,
            }}
          />
        ))}
      </div>

      <div className="relative z-10 bg-[#121225]/95 border border-white/20 backdrop-blur-xl rounded-2xl p-8 max-w-md mx-4 text-center celebration-pop">
        <button
          onClick={dismissCelebration}
          className="absolute top-4 right-4 text-white/50 hover:text-white transition-colors"
          data-testid="close-celebration"
        >
          <X size={20} />
        </button>

        <div className="flex justify-center mb-4">
          <Star className="text-[#FFED00] fill-[#FFED00] w-12 h-12 animate-spin-slow" />
        </div>

        <h2 className="font-outfit text-2xl font-bold text-white mb-2">Lesson Complete!</h2>

        <div className="inline-block bg-gradient-to-r from-[#FF0099] to-[#FF5E00] rounded-full px-6 py-2 mb-4">
          <span className="text-white font-bold text-lg">+{showCelebration.xp} XP</span>
        </div>

        <p className="text-[#A1A1AA] text-base font-quicksand">{message}</p>

        <button
          onClick={dismissCelebration}
          className="mt-6 bg-[#FF0099] hover:bg-[#D60080] text-white rounded-full px-8 py-3 font-bold shadow-[0_0_15px_rgba(255,0,153,0.4)] transition-all hover:scale-105 active:scale-95"
          data-testid="celebration-continue"
        >
          Keep Going!
        </button>
      </div>
    </div>
  );
};

export default CelebrationModal;
